<template>
    <div>
        <div class="form-group p-0-14">
            <div class="signature-attribute">
                <div :id="accordionId" ref="accordion" role="tablist" aria-multiselectable="true">
                    <div class="card">
                        <div class="card-header" role="tab" id="section1HeaderId">
                            <div class="btn-group" role="group">
                                <button type="button" class="collapseButton btn-new-primary btn" data-toggle="collapse" data-parent="#accordianId" :href="`#${sectionId}`"
                                        aria-expanded="false" aria-controls="section1ContentId">
                                    draw {{ attribute.attribute_name }}
                                </button>
                            </div>
                        </div>
                        <div :id="sectionId" class="collapseDiv collapse" role="tabpanel" aria-labelledby="section1HeaderId">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12 col-md-offset-4">
                                        <canvas
                                            ref="canvas"
                                            style="border: 1px solid #000000; border-radius: 5px;"
                                            class="signature-canvas"
                                            @click="removePlaceholder">
                                          <img :src="dataSubmit[`attribute_${attribute.attribute_id}`]" v-if="dataSubmit[`attribute_${attribute.attribute_id}`]">
                                        </canvas>
                                    </div>
                                    <div class="col-md-12 text-center" v-if="captured">
                                        <div class="alert alert-success"> captured successfully </div>
                                    </div>
                                </div>
                                <div class="btn-toolbar" role="toolbar" v-if="isLoading"><img src="/pic/loading-4.gif"></div>
                                <div class="btn-toolbar" role="toolbar" v-else>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-primary" @click="updateSignature">Update
                                            Signature
                                        </button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-default" @click="clearSignature">Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import Api from '../api/index.js';

export default {
    name: "SignatureAttribute",
    props: ["attribute", "dataSubmit", "validationErrors", "constrains", "customerId"],
    data() {
        return {
            image: null,
            canvas: null,
            context: null,
            captured: false,
            url: null,
            isLoading: false
        }
    },
    computed: {
        accordionId() {
            return `accordion_attribute_${this.attribute.attribute_id}`
        },
        sectionId() {
            return `section_${this.attribute.attribute_id}`
        }
    },
    methods: {
        setCanvasSettings() {
            this.canvas = this.$refs['canvas'];
            this.context = this.canvas.getContext("2d");
            new SignaturePad(this.canvas);
        },
        removePlaceholder() {
            this.canvas.classList.remove('signature-canvas')
        },
        resetSignature(){
            this.captured = false;
            this.image = null;
            this.url = null;
            this.isLoading = true;
            this.dataSubmit[`attribute_${this.attribute.attribute_id}`] = null;
        },
        updateSignature() {

            //reset values
            this.resetSignature();

            this.image = this.canvas.toDataURL("image/png", 1.0);

            Api.uploadSignature({
                image: this.image,
                customer_id: this.customerId ? this.customerId : this.constrains.newCustomerId,
                attribute_id: this.attribute.attribute_id,
            }).then(response => {
                if (response.data.status == "success"){
                    this.captured = true;
                    this.url = response.data.result;
                    this.dataSubmit[`attribute_${this.attribute.attribute_id}`] = this.url;
                    this.isLoading = false;
                }
            })
        },
        clearSignature() {
            //reset values
            this.resetSignature();

            // noinspection JSUnresolvedFunction
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.canvas.classList.add('signature-canvas');
            this.isLoading = false;
        }
    },
    mounted() {
        let vm = this;
        this.setCanvasSettings();
        EventBus.$on('resetSignature', function (value) {
            let src = vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`];
            vm.clearSignature();
            $(".collapseButton").addClass('collapsed');
            $(".collapseDiv").removeClass('in').css('height', '0px');
            vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`] = src;
            if (! value){
              let img = new Image();
              img.onload = function(){
                vm.canvas.width = img.width;
                vm.canvas.height = img.height;
                vm.context.drawImage(img, 0, 0, img.width, img.height);
              }
              img.src = src;
            }
        });
    },
    watch:{
      dataSubmit(value){
        if (value){
          EventBus.$emit('resetSignature', false);
        }

      }
    }
}
</script>

<style scoped>
.canvas-control {
    width: 100%;
    min-height: 300px;
}

.signature-canvas {
    background-image: url('/pic/sign-here.png');
    background-repeat: no-repeat;
    background-position: center;
}
</style>